module.exports = __webpack_public_path__ + "img/RENAULT.e10161b2.webp";